// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const ManufacturerLayout = ({ children, title }) => {

	return (
		<div className='ManufacturerLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ManufacturerLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

ManufacturerLayout.defaultProps = {
	children: null,
	title: ''
}

export default ManufacturerLayout;